import { InputLabel, withStyles } from '@material-ui/core';

// This applies a workaround fix for long text label
export default withStyles(() => ({
  root: {
    paddingRight: 5,
    background: 'white'
  }
}))(InputLabel);
